import React from 'react';
import PropTypes from 'prop-types';
import { Pagination } from 'react-bootstrap';

function PaginationGroup(props) {
    let pages = [];
    for (let i = 1; i <= props.maxPage; i++) {
        pages.push(i);
    }

    return (
        <Pagination>
            <Pagination.First onClick={props.handlePrevious} />
            {pages &&
                pages.map((page) => (
                    <Pagination.Item
                        key={page}
                        active={page === props.currentPage}
                        onClick={() => props.handleJump(page)}
                    >
                        {page}
                    </Pagination.Item>
                ))}
            <Pagination.Last onClick={props.handleNext} />
        </Pagination>
    );
}

PaginationGroup.propTypes = {
    handlePrevious: PropTypes.func,
    handleNext: PropTypes.func,
    handleJump: PropTypes.func,
    currentPage: PropTypes.number,
    maxPage: PropTypes.number,
};

PaginationGroup.defaultProps = {
    handlePrevious: () => {},
    handleNext: () => {},
    handleJump: () => {},
    maxPage: 1,
    currentPage: 1,
};

export default PaginationGroup;
